const hasPermission = (permissions, name) =>
  Array.isArray(permissions) && permissions.some((item) => item?.name === name);

export { hasPermission };
